import {useMemo} from 'react'
import useMultiSite from './use-multi-site'
import {useCurrentCustomer} from './use-current-customer'

/*
 * Generates useful information about commerce sites.
 */
export const useCommerceData = () => {
    const {site} = useMultiSite()
    const {data} = useCurrentCustomer()

    // Customer data is only available on client site and after loading it, so it’ll change after several seconds.
    // This implementation is fine for internal testing, but in general it should be changed.
    return useMemo(
        () => ({
            isEcommerceEnabled: !site?.isContentOnlySite || data?.isProductionTestingTeamCustomer
        }),
        [site?.isContentOnlySite, data?.isProductionTestingTeamCustomer]
    )
}
